let store = require("../store");
let actions = require("../actions");

let Pulse = mc.widgets.Pulse;
let Meter = mc.widgets.Meter;

let PasswordRequestView = require("./PasswordRequestView");

class PasswordFormView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      password: "",
      errors: [],
      submitting: false,
      revealed: false,
      success: null // null, true, false
    };
  }

  componentDidMount() {
    let load = mc.loader.load("./vendor/mc/zxcvbn/4.4.2/zxcvbn.js");
    let wait = mc.ui.wait(750);

    Promise.all([wait, load]).then((function () {
      this.setState({
        loaded: true
      });
    }).bind(this));
  }

  setPassword(evt) {
    this.setState({
      password: evt.target.value
    });
  }

  submit(evt) {
    let { userId, resetId } = this.props;
    let password = this.state.password;

    actions.savePassword(userId, resetId, password).then((function (payload) {
      let errors = payload.errors;

      this.setState({
        errors,
        success: errors.length === 0
      });
    }).bind(this));

    this.setState({
      submitting: true
    });

    evt.preventDefault();
  }

  login() {
    actions.logout(true);
    mc.router.trigger("LOGIN_VIEW");
  }

  togglePassword(evt) {
    this.setState({
      revealed: !this.state.revealed
    });
  }

  getPasswordStrength(password) {
    let colors = ["#e00", "#e00", "#fc0", "#fc0", "#0c0"];
    let score = 0;
    let percent = 0;

    if (window.zxcvbn) {
      if (password.length < 8) {
        percent = password.length / 20;
      }
      else {
        score = zxcvbn(password).score;
        percent = 0.4 + (0.6 * (Math.max(0, (score - 1)) / 3));
      }
    }

    return {
      percent,
      color: colors[score]
    };
  }

  requestLink() {
    PasswordRequestView.open();
  }

  render() {
    let { loaded, password, revealed, submitting, success } = this.state;
    let isValid = password.length >= 8 && password.length <= 64;
    let isInvite = /invite$/.test(location.hash);
    let strength = this.getPasswordStrength(password);

    if (!loaded) {
      return <Pulse margin={150}/>;
    }

    let content = (
      <div>
        <p>{isInvite ? tx("create_password") : tx("enter_new_password")}</p>
        <div>
          <input
            name="password"
            type={revealed ? "text" : "password"}
            value={password}
            maxLength="64"
            onChange={this.setPassword.bind(this)}/>
          <a onClick={this.togglePassword.bind(this)}>
            {revealed ? tx("hide") : tx("show")}
          </a>
          <div>
            <Meter width={200} height={8} percent={strength.percent} color={strength.color} animate={true}/>
          </div>
        </div>
        <button name="submit" className="mc-button" disabled={!isValid || submitting} onClick={this.submit.bind(this)}>
          {tx("submit")}
        </button>
        <small>{tx("password_note")}</small>
      </div>
    );

    if (submitting) {
      if (success === true) {
        content = (
          <div>
            <p>
              {tx("password_reset")}
            </p>
            <button name="login" className="mc-button" onClick={this.login.bind(this)}>
              {tx("log_in")}
            </button>
          </div>
        );
      }
      if (success === false) {
        content = (
          <div>
            <p>{tx("password_not_reset")}</p>
            <button onClick={this.requestLink.bind(this)}>
              {tx("request_new_link")}
            </button>
          </div>
        );
      }
    }

    return (
      <div className="rc-password-form-view" data-success={success}>
        <img src="./img/rc/padlock.svg" width="75" height="100"/>
        {content}
      </div>
    );
  }
}

module.exports = PasswordFormView;